import { EHumanReviewTab, matchesActiveSubject, type THumanReviewDetail } from '../human-review-requests.type'
import { useLocale } from 'src/hooks/use-locale'
import { isResolvedRequest } from '../resolution/resolution-note.component'
import { ProblemResolutions } from './problem-resolutions.component'
import { ProblemCard } from './problem-card.component'
import {
  getNewConvocationDate,
  groupIntoProblemCards,
  shouldCollapseCardsByDefault,
} from './problem-card.util'

type Props = {
  humanReviewDetail: THumanReviewDetail
  activeSubject: EHumanReviewTab
}

export const ProblemContent = ({ humanReviewDetail, activeSubject }: Props) => {
  const { locale } = useLocale()
  const { reviewRequests } = humanReviewDetail
  const newDate = getNewConvocationDate(humanReviewDetail.patientMedEvent)

  const allUnresolved = reviewRequests.filter((request) => !request.resolution)

  const currentSubjectUnresolved = allUnresolved.filter((request) =>
    matchesActiveSubject(request.subject, activeSubject),
  )
  const currentSubjectResolved = reviewRequests
    .filter(isResolvedRequest)
    .filter((request) => matchesActiveSubject(request.subject, activeSubject))

  const unresolvedCards = groupIntoProblemCards(currentSubjectUnresolved)
  const resolvedCards = groupIntoProblemCards(currentSubjectResolved)
  const collapseUnresolvedCards = shouldCollapseCardsByDefault(unresolvedCards, locale)

  return (
    <div className="c-flex c-flex-col c-mt-4 c-mb-3">
      <div className="c-flex c-flex-col c-gap-4">
        {unresolvedCards.map(({ key, requests }) => (
          <ProblemCard
            key={key}
            requests={requests}
            patient={humanReviewDetail.patient}
            newDate={newDate}
            defaultExpanded={!collapseUnresolvedCards}
          />
        ))}
      </div>

      <ProblemResolutions
        unresolvedRequests={currentSubjectUnresolved}
        patientMedEventId={humanReviewDetail.patientMedEvent.id}
        patient={humanReviewDetail.patient}
      />

      {resolvedCards.length > 0 && (
        <>
          {unresolvedCards.length > 0 && <div className="c-ml-4 c-mb-4 c-border-t c-border-grey-300" />}
          <div className="c-flex c-flex-col c-gap-4">
            {resolvedCards.map(({ key, requests }) => (
              <ProblemCard
                key={`resolved-${key}`}
                requests={requests}
                patient={humanReviewDetail.patient}
                newDate={newDate}
                defaultExpanded={false}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
